import { useState } from "react";
import { motion } from "motion/react"


const faqs = [
  {
    question: "What services does AK Jodem Limited offer?",
    answer: "We specialize in real estate sales, rentals, shortlets, property development, and construction. Whether you’re buying, investing, or seeking professional advice, we’re here to guide you every step of the way."
  },
  {
    question: "Where are your properties located?",
    answer: "Our properties are primarily located in Lagos, Ibadan, and other fast-developing areas across Nigeria. We also offer site inspections to help you choose the best option for your budget and lifestyle."
  },
  {
    question: "Do I need to be physically present to buy a property?",
    answer: "No, you don’t. We handle remote transactions securely and transparently. Virtual tours, documentation, and inspections can all be arranged for clients in or outside Nigeria."
  },
  {
    question: "What documents will I receive after purchasing a property?",
    answer: "You will receive key documents such as a receipt of payment, contract of sale, allocation letter, and applicable title documents (e.g., survey plan, deed of assignment, C of O, or excision, depending on the property)."
  },
  {
    question: "Can I pay in installments?",
    answer: "Yes! Most of our properties come with flexible payment plans ranging from 3 to 12 months. You can start with an initial deposit and spread the balance conveniently."
  },
  {
    question: "How do I know the property is genuine?",
    answer: "All AK Jodem properties are verified and come with clear, traceable titles. We conduct thorough due diligence and encourage clients to involve their legal representatives for transparency."
  },
  {
    question: "Does AK Jodem Limited offer referral or partnership programs?",
    answer: "Yes, we do. We work with realtors and partners who earn commissions for closing deals with us. Reach out to learn how you can become a partner or earn by referring others."
  },
  {
    question: "What makes AK Jodem different from other real estate companies?",
    answer: "Our commitment to honesty, excellent customer service, and delivering value sets us apart. We prioritize long-term client satisfaction and help turn real estate goals into lasting investments."
  },
  {
    question: "Can I build immediately after buying land?",
    answer: "Yes, for most of our properties, once payment is completed and allocation is done, you are free to begin construction—subject to local regulations and estate guidelines."
  },
  {
    question: "How can I contact AK Jodem Limited?",
    answer: "You can reach us via:\nPhone: 08065084918\nEmail: akjodem@gmail.com\nInstagram: @akjodemlimited\nOr visit our office in Lagos or Ibadan for a face-to-face consultation."
  }
];

const Faqs = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="my-8">
      <h1 className="mb-6 font-bold text-2xl text-center">Real Estate FAQs</h1>
      <p className="mb-6 text-center">
        At AK-JODEM, we believe in delivering value
        to our clients through our expertise and
        commitment to excellence.
      </p>
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, translateY: 200 }}
            whileInView={{ opacity: 1, scale: 1, translateY: 0 }}
            transition={{ duration: 0.7, ease: "easeOut", delay: Number(`0.${index}`) }}
            key={index}
            className="shadow-sm p-4 border border-gray-300 rounded-md"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="flex justify-between w-full text-left"
            >
              <span className="font-medium text-lg">{faq.question}</span>
              <span className="text-gray-500">
                {openIndex === index ? "-" : "+"}
              </span>
            </button>
            {openIndex === index && (
              <p className="mt-2 text-gray-600">{faq.answer.split('\n').map((line, index) => (
                <span key={index}>{line}<br /></span>
              ))}</p>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Faqs;
